import React, { useEffect, useRef, useState } from 'react';
import axios from 'axios';
import { confirmAlert } from 'react-confirm-alert';
import { toast } from 'react-toastify';
import { authHeader } from '@H';
import ShiftList from './ShiftList';

const Shifts = () => {
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const editRef = useRef(null);
  const [shiftData, setShiftData] = useState([
    {
      shift: '',
      updated: false,
      editMode: false,
    },
  ]);

  const handleChange = (e) => {
    setShiftData({
      ...shiftData,
      [e.target.name]: e.target.value,
    });
  };

  const cancelEdit = () => {
    setShiftData({
      shift: '',
      updated: shiftData.updated,
      editMode: false,
    });
  };

  const handleEditMode = (shift) => {
    setShiftData({
      uuid: shift.uuid,
      shift: shift.shift,
      updated: shiftData.updated,
      editMode: true,
    });
    if (editRef.current) {
      window.scrollTo({
        behavior: 'smooth',
        top: editRef.current.offsetTop - 150,
      });
    }
  };

  const confirmSubmit = (e) => {
    const { shift } = shiftData;
    confirmAlert({
      title: 'Are you sure you want to',
      message: shiftData.editMode ? `update ${shift}` : 'add a new shift',
      buttons: [
        {
          label: 'Yes',
          onClick: () => submitForm(e),
        },
        {
          label: 'No',
          onClick: () => false,
        },
      ],
    });
  };

  const submitForm = (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    const headers = authHeader(1);
    const url = `${process.env.API_URL}/bunk/shifts/shifts-set/`;
    let method = 'POST';
    let formData = shiftData;
    if (shiftData.editMode) {
      method = 'PUT';
      formData = { uuid: shiftData.uuid, shift: shiftData.shift };
    }
    axios({
      method,
      url,
      data: formData,
      headers,
    })
      .then(() => {
        toast.success('Shift added successfully');
        window.scrollTo({
          behavior: 'smooth',
          top: editRef.current.offsetTop - 150,
        });
        setIsSubmitting(false);
        setShiftData({
          shift: '',
          updated: !shiftData.updated,
          editMode: false,
        });
      })
      .catch((err) => {
        toast.error(err?.response?.data?.message);
        setIsSubmitting(false);
      });
  };

  return (
    <>
      <section className="widget full-width form-table" ref={editRef}>
        <header>
          <h3>  Shifts</h3>
        </header>
        <main>
          <div className="form-content">
            <table>
              <thead>
                <tr>
                  <th> Shift </th>
                  <th>Actions</th>
                </tr>
              </thead>
              <tbody>
                <tr className={`${shiftData.editMode ? 'highlight-bg' : ''}`}>
                  <td>
                    <div className="input-wrapper">
                      <input
                        name="shift"
                        type="text"
                        onChange={handleChange}
                        placeholder="Shift"
                        value={shiftData.shift}
                      />
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
            <div className="form-actions">
              <button className="submit" type="submit" onClick={confirmSubmit}>
                Submit
              </button>
              {shiftData.editMode && (
                <button className="red-btn" onClick={cancelEdit}>
                  Cancel
                </button>
              )}
            </div>
          </div>
        </main>
      </section>
      <ShiftList key={shiftData.updated} onEdit={handleEditMode} />
    </>
  );
};
export { Shifts };
